import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BackButton = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <button
      onClick={goBack}
      className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#121212] text-[#00F0FF] font-semibold shadow-lg hover:bg-[#1A1A1A] transition-all duration-200 border border-[#00F0FF] hover:border-[#FF007F]"
    >
      <ArrowLeft size={20} /> Back
    </button>
  );
};

export default BackButton;